module.exports = __webpack_public_path__ + "static/media/img11.98a029bb.jpg";